import i18next from 'i18next';

i18next.addResources('es_CL', 'QRModal', {
  changePaymentMethod: 'Elegir otro medio de pago',
  title: 'Escanear el QR',
  description: 'Abre la aplicación {{method}} en tu dispositivo y escanea el código QR.',
  total: 'Valor a pagar'
});
